import {
  AbstractControl,
  AsyncValidatorFn,
  FormArray,
  FormControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

/** Nullable control for arbitrary value types (arrays, numbers, objects, etc.). */
export function createNullableControl<T>(
  initialValue: T | null,
  validators?: ValidatorFn | ValidatorFn[],
  asyncValidators?: AsyncValidatorFn | AsyncValidatorFn[]
): FormControl<T | null> {
  return new FormControl<T | null>(initialValue, {
    validators,
    asyncValidators,
  });
}

export function createNullableStringControl(
  initialValue: string | null,
  validators?: ValidatorFn | ValidatorFn[],
  asyncValidators?: AsyncValidatorFn | AsyncValidatorFn[]
): FormControl<string | null> {
  return createNullableControl(initialValue, validators, asyncValidators);
}

export function createNullableBooleanControl(
  initialValue: boolean | null,
  validators?: ValidatorFn | ValidatorFn[],
  asyncValidators?: AsyncValidatorFn | AsyncValidatorFn[]
): FormControl<boolean | null> {
  return createNullableControl(initialValue, validators, asyncValidators);
}

/**
 * Replaces all controls in `arr` with one `FormControl` per id (subcategory / issue ids).
 */
export function syncFormArrayControlIds(
  arr: FormArray<FormControl<string>>,
  ids: string[]
): void {
  arr.clear();
  for (const id of ids) {
    arr.push(new FormControl<string>(id, { nonNullable: true }));
  }
}

/** At least one entry in a {@link FormArray} of subcategory / issue id controls. */
export function nonEmptyFormArrayValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const idFormArray  = control as FormArray<FormControl<string>>;
    return idFormArray?.length > 0 ? null : { required: true };
  };
}
